import { render, staticRenderFns } from "./GraphDetail54.vue?vue&type=template&id=fa215e84&scoped=true"
import script from "./GraphDetail54.vue?vue&type=script&lang=js"
export * from "./GraphDetail54.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa215e84",
  null
  
)

export default component.exports